import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, mergeProps as _mergeProps, createElementBlock as _createElementBlock } from "vue"

import { toRef } from 'vue'

interface IProps {
  label?: string
  labelClass?: string
  color?: string
  textColor?: string
  borderColor?: string
  borderless?: boolean
  status?: string
  info?: string
  infoClass?: string
  title?: boolean
  clearable?: boolean
  outline?: boolean
  disable?: boolean
  hoverless?: boolean
  size?: 'sm' | 'md'
  icon?: string
  iconColor?: string
  iconSize?: string
  rootClass?: string | (string | Record<PropertyKey, boolean>)[] | Record<PropertyKey, boolean>
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'KStatus', inheritAttrs: false },
  __name: 'KStatus',
  props: {
    label: { default: '' },
    labelClass: { default: '' },
    color: { default: 'white' },
    textColor: { default: 'cool-gray-100' },
    borderColor: { default: 'cool-gray-30' },
    borderless: { type: Boolean, default: false },
    status: { default: '' },
    info: { default: '' },
    infoClass: { default: 'status-info' },
    title: { type: Boolean, default: false },
    clearable: { type: Boolean, default: false },
    outline: { type: Boolean, default: false },
    disable: { type: Boolean, default: false },
    hoverless: { type: Boolean, default: false },
    size: { default: 'md' },
    icon: { default: '' },
    iconColor: { default: '' },
    iconSize: { default: '12px' },
    rootClass: { default: '' }
  },
  emits: ['cleared'],
  setup(__props: any) {

_useCssVars(_ctx => ({
  "v4ee989d5": (borderColor.value)
}))



const props = __props

const borderColor = toRef(() => `var(--${props.borderColor})`)

return (_ctx: any,_cache: any) => {
  const _component_k_colour_dot = _resolveComponent("k-colour-dot")!
  const _component_k_icon = _resolveComponent("k-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["k-status inline row items-center status-container", [__props.rootClass]])
  }, [
    _renderSlot(_ctx.$slots, "before"),
    _createElementVNode("div", _mergeProps({
      class: ["flex flex-center k-status__main inline", [
        `bg-${__props.color} text-${__props.textColor}`,
        `k-status__${__props.size}`,
        {
          'k-status__border': !__props.borderless && !__props.title,
          'k-status__title fs-19px fw-600': __props.title,
          'k-status__status': __props.status,
          'k-status__clearable': __props.clearable,
          'k-status__outline': __props.outline,
          'k-status__disabled': __props.disable,
          'k-status__hoverless': __props.hoverless,
          'k-status__prepend': __props.icon || __props.status,
          'fs-13px fw-500': !__props.title,
        },
      ]]
    }, _ctx.$attrs), [
      _renderSlot(_ctx.$slots, "prepend"),
      _renderSlot(_ctx.$slots, "default", {}, () => [
        (__props.status && !_ctx.$slots.status && !__props.icon)
          ? (_openBlock(), _createBlock(_component_k_colour_dot, {
              key: 0,
              size: __props.iconSize,
              color: __props.status,
              class: "q-mr-xs"
            }, null, 8, ["size", "color"]))
          : (!_ctx.$slots.status && __props.icon)
            ? (_openBlock(), _createBlock(_component_k_icon, {
                key: 1,
                name: __props.icon,
                color: __props.iconColor,
                size: __props.iconSize,
                class: "q-mr-xs"
              }, null, 8, ["name", "color", "size"]))
            : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "status"),
        _renderSlot(_ctx.$slots, "label", {}, () => [
          _createElementVNode("label", {
            class: _normalizeClass(__props.labelClass)
          }, _toDisplayString(__props.label), 3)
        ])
      ]),
      _renderSlot(_ctx.$slots, "append", {}, () => [
        _renderSlot(_ctx.$slots, "append", {}, () => [
          (__props.clearable)
            ? (_openBlock(), _createBlock(_component_k_icon, {
                key: 0,
                class: "k-status__clear cursor-pointer",
                name: "remove",
                size: "20px",
                color: "inherit",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('cleared')))
              }))
            : _createCommentVNode("", true)
        ])
      ])
    ], 16),
    (__props.info)
      ? _renderSlot(_ctx.$slots, "info", { key: 0 }, () => [
          _createElementVNode("span", {
            class: _normalizeClass(["q-ml-sm", __props.infoClass])
          }, _toDisplayString(__props.info), 3)
        ])
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "after")
  ], 2))
}
}

})